import { gql } from "@apollo/client";

const ADD_TOR_COMPONENT_TABLE_D = gql`
    mutation addToRComponentTableD($torID: String!, $laID: String!, $componentCode: String!, $componentTitle: String!, $gradeRegistered: String, $ects: String!, $semester: String){
        addToRComponentTableD(torID: $torID, laID: $laID, componentCode: $componentCode, componentTitle: $componentTitle, gradeRegistered: $gradeRegistered, ects: $ects, semester: $semester)
  }
`;

export default ADD_TOR_COMPONENT_TABLE_D;
